import CryptoJS from 'crypto-js';
const encrypt_key = process.env.REACT_APP_ENCRYPTION_KEY;

export const filterData = (propertiesToKeep, dataArray) => {
    return dataArray.map(data => {
        const newData = {};

        propertiesToKeep.forEach(property => {
            newData[property] = data.hasOwnProperty(property) ? (Array.isArray(data[property]) ? data[property] : [data[property]]) : "N/A";
        });
        return newData;
    });
}

export const filterData1 = () => {
    // get the form data from the DOM elements
}
// encrypt and decode data
const getKey = () => CryptoJS.enc.Utf8.parse(encrypt_key).toString(CryptoJS.enc.Base64);
export const encryptDecryptData = {
    encrypt: (data) => {
        try {
            if (!data) return
            const key = getKey();
            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
            return encrypted;
        } catch (error) {
            console.error('Encryption failed:', error);
            throw new Error('Encryption failed ' + error);
        }
    },

    decrypt: (data) => {
        try {
            if (!data) return
            const key = getKey();
            const decrypted = CryptoJS.AES.decrypt(data, key);
            const decryptedData = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
            return decryptedData;
        } catch (error) {
            console.error('Decryption failed:', error);
            throw new Error('Decryption failed ' + error);
        }
    },
};
